<template>
  <a-modal
    :width="1080"
    v-model="vable"
    @ok="flashOk"
    :footer="null"
    :loading="loading"
    :maskClosable="false"
    @cancel="handleCancel(bookId,flashType)"
  >
    <span slot="title">
      <span v-if="study === '1' && period === '3'">
        当前教材：高中英语 > {{ press }} > {{ required | studyFolter }} > {{ name }}
      </span>
      <span v-else-if="study === '2' && period === '3'">
        当前教材：高中英语 > {{ press }} > {{ elective | studyFolter2 }} > {{ name }}
      </span>
      <span v-else-if="grade <= '6' && grade !=''">
        当前教材：小学英语 > {{ press }} > {{ grade | gradeFolter }}{{ volume | volumeFolter }} > {{ name }}
      </span>
      <span v-else-if="flashType =='1' ">
        词语速记作业 : {{ homeworkName }}
      </span>
      <span v-else-if="flashType =='2' ">
        错词本：
      </span>
      <span v-else>
        当前教材：初中英语 > {{ press }} > {{ grade | gradeFolter }}{{ volume | volumeFolter }} > {{ name }}
      </span>
    </span>
    <iframe
      style="width: 100%;height: 710px;"
      :src="src"
      seamless
      scrolling="no"
      frameborder="0"
    />
  </a-modal>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  components: {
    mapGetters
  },
  computed: {
    ...mapGetters(['studentId'])
  },
  data () {
    return {
      queryParam: {},
      vable: false,
      loading: true,
      bookId: '',
      unitId: '',
      period: '',
      press: '',
      required: '',
      elective: '',
      grade: '',
      study: '',
      volume: '',
      name: '',
      scoreId: '',
      flashType: '',
      homeworkName: '',
      examPaperId: ''
    }
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['src'],
  filters: {

    volumeFolter (volume) {
      const volumeMap = {
        1: '上册',
        2: '下册',
        3: '全一册'
      }
      return volumeMap[volume]
    },
    studyFolter (value) {
      const studyMap = {
        1: '必修一',
        2: '必修二',
        3: '必修三',
        4: '必修四',
        5: '必修五'
      }
      return studyMap[value]
    },
    studyFolter2 (value) {
      const studyMap = {
        1: '选修六',
        2: '选修七',
        3: '选修八',
        4: '选修九',
        5: '选修十',
        6: '选修十一'
      }
      return studyMap[value]
    },
    gradeFolter (grade) {
      const gradeMap = {
        1: '一年级',
        2: '二年级',
        3: '三年级',
        4: '四年级',
        5: '五年级',
        6: '六年级',
        7: '七年级',
        8: '八年级',
        9: '九年级',
        10: '高一',
        11: '高二',
        12: '高三'
      }
      return gradeMap[grade]
    }
  },
  methods: {
    flashWrong (current, flashType) {
      this.current = current

      this.flashType = flashType
      this.vable = true
      const studentId = this.studentId
      localStorage.setItem('current', current)
      localStorage.setItem('flashType', flashType)
      localStorage.setItem('studentId', studentId)
    },
    flashSeehomework (homeworkName, examPaperId, flashType, id) {
      this.homeworkName = homeworkName
      this.unitId = examPaperId
      this.vable = true
      this.flashType = flashType
      this.examPaperIdTrue = id
      const unitId = examPaperId
      const studentId = this.studentId
      const examPaperIdTrue = id
      localStorage.setItem('unitId', unitId)
      localStorage.setItem('homeworkId', examPaperIdTrue)
      localStorage.setItem('studentId', studentId)
      localStorage.setItem('flashType', flashType)
    },
    flashSee (bookId, id, study, period, press, required, elective, grade, volume, name, scoreId, flashType) {
      // this.queryParam.textId = id
      // console.log('单元' + JSON.stringify(this.queryParam.textId))
      // getTextContentList(this.queryParam).then(res => {
      //   this.textContentList = res.result
      //   console.log('textContentList' + JSON.stringify(this.textContentList))
      // })
      // this.vable = true
      this.bookId = bookId
      this.unitId = id
      this.study = study
      this.period = period
      this.press = press
      this.required = required
      this.elective = elective
      this.grade = grade
      this.volume = volume
      this.name = name
      this.scoreId = scoreId
      this.flashType = flashType
      // console.log('flashType' + JSON.stringify(this.flashType))
      this.vable = true
      const unitId = id
      const scoreId1 = scoreId
      const studentId = this.studentId
      // console.log('studentId' + JSON.stringify(studentId))
      localStorage.setItem('unitId', unitId)
      localStorage.setItem('id', scoreId1)
      localStorage.setItem('studentId', studentId)
      localStorage.setItem('flashType', flashType)
    },
    flashOk () {
      this.vable = false
    },
    handleCancel (bookId, flashType) {
      this.vable = false
      this.bookId = bookId
      if (flashType === '1') {
        this.$emit('watchChild')
        // console.log('bookId')
      } else {
        // 刷新页面
        // window.open('/learncenter/BookUnit', self)
        // location.reload()
        // console.log('bookId' + JSON.stringify(bookId))
        // this.$parent.selectUnit(bookId)
        // console.log('bookId' + JSON.stringify(bookId))
        this.$emit('watchChild', bookId)
      }
    }
  }
}
</script>
<style>
</style>
